<div id="organization_dash" class="m-5">
  <div class="mobile-nav-dash">
    <button class="upcoming-order-btn" (click)="upcomingbtn()">
      Upcoming Orders
    </button>
    <button class="events-btn" (click)="eventbtn()">Events</button>
  </div>
  <div class="container">
    <div class="Section_PH">
      <div class="row">
        <div
          class="col-xs-12 col-sm-12 col-md-4 col-lg-4"
          id="upcoming-order-sect"
        >
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-12">
                <h1>Calendar</h1>
                <mat-card
                  class="demo-inline-calendar-card"
                  id="demo-inline-calendar-card_id"
                >
                  <mat-calendar
                    [(selected)]="selected"
                    [minDate]="todayDate"
                    (selectedChange)="onChangeDate($event)"
                    [calendarLabel]="false"
                  ></mat-calendar>
                </mat-card>
              </div>

              <div class="col-sm-12" style="margin-top: 21px">
                <h1>Upcoming Orders</h1>
                <div class="img36" *ngIf="UpcomingOrderList.length === 0">
                  <img
                    style="margin-top: 10%"
                    src="../../../../assets/icons/36.png"
                  />
                </div>

                <div
                  *ngIf="UpcomingOrderList.length >= 1"
                  id="UpcomingOrdsCss"
                  class="UpcomingOrdsCss"
                >
                  <mat-card
                    class="eventCard"
                    *ngFor="let item of UpcomingOrderList"
                    style="margin-bottom: 15px"
                  >
                    <div class="row">
                      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <h3 class="upOrdTitle">
                          {{ item.eventData[0]?.eventTitle }}
                        </h3>
                        <!-- <h3 class="upOrdTitle">{{item.restaurantData[0]?.restaurantName}}</h3> -->
                      </div>
                    </div>
                    <div class="row">
                      <div
                        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 upcomcard"
                      >
                        <mat-icon class="mt10"
                          ><img
                            class="eventicons"
                            src="../../../../assets/icon/calendar-event.png"
                            width="24"
                            height="24"
                        /></mat-icon>
                        &nbsp;
                        <span class="upOrdText">{{
                          item.eventData[0]?.eventDate
                            | date : "MMM dd, YYYY" : "UTC"
                        }}</span>
                      </div>
                      <div
                        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 upcomcard"
                      >
                        <mat-icon class="mt10"
                          ><img
                            class="eventicons"
                            src="../../../../assets/icon/soup.png"
                            width="24"
                            height="24" /></mat-icon
                        >&nbsp;
                        <span
                          class="upOrdText"
                          style="overflow-wrap: anywhere"
                          >{{ item.restaurantData[0]?.restaurantName }}</span
                        >
                        <!-- <span class="upOrdText">{{item.items[0]?.productData?.productName}}</span> -->
                      </div>
                      <div
                        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 row_top"
                      >
                        <button
                          class="f-delivary devlicerButton"
                          *ngIf="
                            item?.eventData.length != 0 &&
                            item.eventData[0]?.deliveryMethod == 'delivery'
                          "
                        >
                          {{ item.eventData[0]?.deliveryMethod | titlecase }}
                        </button>

                        <button
                          class="f-pickup"
                          *ngIf="
                            item?.eventData.length != 0 &&
                            item.eventData[0]?.deliveryMethod == 'pickup'
                          "
                        >
                          {{ item.eventData[0]?.deliveryMethod | titlecase }}
                        </button>
                      </div>
                    </div>
                  </mat-card>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8" id="event-sect">
          <div
            class="add-team-btn-sect"
            style="
              display: flex;
              justify-content: space-between;
              margin-bottom: 25px;
            "
          >
            <div class="e2">
              <!-- <div class="col-sm-4 colxs-4 col-md-8 col-lg-8  margin_top align_center_mob"> -->
              <span class="events">Events</span>
            </div>

            <div class="" style="" *ngIf="EventList.length > 0 || selected">
              <button class="addEvent-button_top" (click)="addEvent()">
                Add Events
              </button>
            </div>

            <div
              class=""
              style=""
              *ngIf="
                this.search !== undefined &&
                this.search != '' &&
                EventList.length == 0 &&
                !selected
              "
            >
              <button class="addEvent-button_top" (click)="addEvent()">
                Add Events
              </button>
            </div>
          </div>

          <!-- Search start -->
          <!-- <div style="margin-top: 0px; margin-bottom: 10px;" class="search-container">
            <mat-icon matSuffix>search</mat-icon>
            <input type="text" class="search-input" placeholder="Search" [(ngModel)]="search" (keyup)="searchData()">
          </div> -->

          <div class="input-group">
            <span class="input-group-text searchImg"
              ><mat-icon style="height: auto" class="searchiconioss"
                ><img src="../../../../assets/icon/search.png" /></mat-icon
            ></span>

            <input
              type="text"
              class="form-control search-input"
              placeholder="Search event name"
              [(ngModel)]="search"
              (keyup)="searchData()"
            />
            <span
              *ngIf="search"
              (click)="clearFilter()"
              class="search-12 searchfieldmob3"
            >
              <img
                src="../../../../../assets/SVG/icon-close-512 (1).webp"
                height="25"
                width="25"
                (click)="clearFilter()"
                alt=""
            /></span>
          </div>

          <!-- <div class="event-image" *ngIf="EventList.length == 0 ">
            <img src="../../../../assets/icons/add-event.png" alt="" />
            <button class="custom-button addEvent-button_center " (click)="addEvent()">Add Events</button>
          </div> -->

          <!-- <div id="addEvent_sec1" class="mt-3"
            *ngIf="EventList.length == 0 && this.search !== undefined &&  this.search != '' "> -->
          <div
            id="addEvent_sec1"
            class="mt-3"
            *ngIf="EventList.length == 0 && (this.search || this.selected)"
          >
            <mat-card
              style="
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <div class="row nodataEvent" style="padding-top: 0 !important">
                <h3
                  style="
                    font-size: 20px !important;
                    margin-bottom: 0 !important;
                  "
                >
                  No Events Found
                </h3>
              </div>
            </mat-card>
          </div>

          <div
            id="addEvent_sec1"
            class="mt-3"
            *ngIf="
              EventList.length == 0 &&
              (this.search === undefined || this.search == '') &&
              !this.selected
            "
          >
            <mat-card>
              <div class="row nodataEvent">
                <div class="col-sm-12">
                  <img src="../../../../assets/icons/add-event.png" alt="" />
                </div>
                <div class="col-sm-12 margin_top">
                  <button
                    class="custom-button addEvent-button_center"
                    (click)="addEvent()"
                  >
                    Add Events
                  </button>
                </div>
              </div>
            </mat-card>
            <br />
          </div>

          <!-- My code ---------------------------------->
          <div *ngIf="EventList.length > 0">
            <div class="row">
              <div
                class="col-lg-6 col-md-12 col-sm-12 col-xs-12"
                style="margin-top: 20px"
                *ngFor="let data of EventList; let index = index"
              >
                <div
                  style="
                    background: rgba(245, 246, 252, 1);
                    border-radius: 20px;
                  "
                  class="card-height"
                >
                  <div style="padding: 20px">
                    <div
                      class="rest-img-address"
                      style="display: flex; gap: 10px"
                    >
                      <div>
                        <img [src]="data.restaurantData.logo" />
                      </div>
                      <div style="display: flex">
                        <div class="rest-text" style="overflow-wrap: anywhere">
                          <!-- {{data.restaurantData.restaurantName | slice:0:17}}<span
                            *ngIf="(data.restaurantData.restaurantName + '').length > 17">...</span> -->
                          <div class="spaceforDesktop">
                            {{
                              data.restaurantData.restaurantName
                                | slice : 0 : 40
                            }}
                            <span
                              *ngIf="
                                (data.restaurantData.restaurantName + '')
                                  .length > 40
                              "
                              >...</span
                            >
                          </div>

                          <!-- {{data.restaurantData.restaurantName}} -->

                          <div
                            class="loc-text"
                            style="margin-top: 5px; display: flex"
                          >
                            <span
                              ><img
                                class="map-img"
                                src="../../../../assets/icons/map-pin.svg"
                            /></span>
                            <span
                              >{{
                                checkResolution(data.restaurantData.address)
                              }}
                              <!-- <span *ngIf="(data.restaurantData.address + '').length > 69">...</span> -->
                            </span>
                          </div>
                        </div>

                        <div>
                          <img
                            (click)="addFavourite(data?.restaurantData?._id)"
                            id="restaurantId{{ data?.restaurantData?._id }}"
                            name="image{{ index }}"
                            class="heart-img{{
                              data?.restaurantData?._id
                            }} heart-img cursor"
                            src="../../../../assets/icons/heart-filled (1).png"
                            *ngIf="data?.restaurantData?.isFavourite == false"
                          />
                          <img
                            (click)="removeFavourite(data?.restaurantData?._id)"
                            id="restaurantId{{ data?.restaurantData?._id }}"
                            name="image{{ index }}"
                            class="heart-img{{
                              data?.restaurantData?._id
                            }} heart-img cursor"
                            src="../../../../assets/icons/heart-filled.png"
                            style="height: 30px; width: 30px"
                            *ngIf="data?.restaurantData?.isFavourite == true"
                          />
                        </div>
                      </div>
                      <div
                        class="active-point"
                        *ngIf="data?.undeliveredCount > 0"
                      >
                        <img
                          class="point"
                          src="../../../../assets/icons/checkmark.png"
                        />
                      </div>
                    </div>

                    <div
                      class="time-clock-event"
                      style="margin-top: 15px; padding-bottom: 15px"
                    >
                      <div
                        class="game-text"
                        [ngClass]="{
                          club_card_max_height: data.eventTitle.length < 28
                        }"
                      >
                        {{ data.eventTitle }}
                      </div>

                      <div>
                        <div class="june-time">
                          <img src="../../../../assets/icons/Calendar.png" />
                          &nbsp;<span>{{
                            formatEventDate(data?.eventDateTime)
                          }}</span
                          >&nbsp;&nbsp;

                          <img src="../../../../assets/icon/TimeCircle.png" />
                          &nbsp;<span>{{
                            formatEventTime(data?.eventDateTime)
                          }}</span>
                        </div>
                      </div>

                      <div style="display: flex; gap: 20px; margin-top: 10px">
                        <div>
                          <button class="delivary-btn delivary-btn-dashboard">
                            {{ data.deliveryMethod | titlecase }}
                          </button>
                        </div>
                        <div>
                          <button
                            class="view-menu-btn view-menu-btn-dashboard"
                            id="viewmenuboldness"
                            (click)="onViewMenuClicked(data)"
                          >
                            View Menu
                          </button>
                        </div>

                        <div>
                          <button
                            class="view-menu-btn view-menu-btn-dashboard"
                            id="viewmenuboldness"
                            (click)="onPlayerOrdersClicked(data)"
                          >
                            Player Orders
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Add events pop up -->
    <!-- <ng-template #ProfilePicCropModal>
    <div style="padding: 50px" class="col-md-12 col-sm-12 col-xs-12 col-lg-12 row">

      <div style="margin-bottom: 15px; display: flex; justify-content: flex-end"
        class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
        <img src="../../../../assets/icons/Info Circle.png" alt="" (click)="modalRef.hide()" />
      </div>

      <div style="margin-bottom: 25px" class="addeve-sty">Add events</div>

      <form [formGroup]="eventForm">
        <div>
          <mat-form-field appearance="fill">
            <input matInput type="text" value="" placeholder="Enter event title" formControlName="title" />
          </mat-form-field>
        </div>

        <div>
          <mat-form-field appearance="fill">
            <input matInput [matDatepicker]="dp" formControlName="date" placeholder="Select event date" />
            <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
            <mat-datepicker #dp></mat-datepicker>
          </mat-form-field>
        </div>

        <div>
          <mat-form-field appearance="fill">
            <input matInput type="text" value="" placeholder="Enter delivery time" formControlName="delivary" />
            <span matSuffix><img src="../../../../assets/icons/clock-hour-3.png" /></span>
          </mat-form-field>
        </div>

        <div class="select-team">Select teams</div>
        <div class="gry-col">
          <div class="col-md-4">
            <img src="../../../../assets/icons/Ellipse23.png" alt="" />
          </div>

          <div class="col-md-4 royal-text">Royal King</div>
          <div class="check-box">
            <input style="width: 20px" type="checkbox" formControlName="team" />
          </div>
        </div>
        <div>
          <mat-form-field appearance="fill">
            <input matInput type="text" value="" placeholder="Comments" formControlName="comment" />
          </mat-form-field>
        </div>
      </form>
      <div>
        <button mat-raised-button color="warn" [disabled]="
            eventForm.value.title == '' ||
            eventForm.value.date == undefined ||
            eventForm.value.delivary == '' ||
            eventForm.value.team == ''
          " (click)="onclickNext()">
          Next
        </button>
      </div>
    </div>
  </ng-template> -->

    <ng-template #ProfilePicCropModal backdrop="true">
      <app-add-event-popup
        (eventFormData)="getEventFormData($event)"
        (closePopup)="closeAddEventPopup()"
      ></app-add-event-popup>
      <!-- something comes here -->
    </ng-template>

    <!-- Select restuent -->

    <ng-template #selectresturent>
      <app-select-restaurant
        (eventFormData)="getSelectRestaurantFormData($event)"
        (getRestaurantDetails)="getRestaurantDetails($event)"
        [selectedRestaurantDetails]="selectedRestaurantDetails"
        (closeSelectRestaurantPopup)="closeSelectRestaurantModal()"
      ></app-select-restaurant>
    </ng-template>
    <!-- view Details -->

    <ng-template #viewdetails>
      <app-view-details
        (getRestaurantProducts)="getRestaurantProducts($event)"
        (clickBack)="onclickback()"
        (selectedRestaurant)="selectedRestaurant($event)"
        (closeSelectRestaurantPopup)="closeSelectRestaurantPopup()"
        [restaurantListByUser]="restaurantListByUser"
      ></app-view-details>
    </ng-template>

    <!-- view menu pop up-------------------------------- -->

    <ng-template #viewmenudetailsdesh>
      <app-view-menu-details
        [productsList]="productsList"
        (clickmenuback)="onclickmenuback()"
      ></app-view-menu-details>
    </ng-template>

    <!-- Delivary Pop up -->

    <ng-template #delivary>
      <app-select-delivery-method
        [selectRestaurantData]="selectRestaurantData"
        (clickAddEvent)="clickAddEvent($event)"
        (closeModalDeliveryMethodPopup)="closeModalDeliveryMethod()"
      ></app-select-delivery-method>
    </ng-template>
  </div>
</div>
